enum EBridgeStatus {
	Pending = 'Running',
	Completed = 'Completed',
}

export default EBridgeStatus;
